export default __webpack_public_path__ + "static/media/radio-di-empty.bdb599eb.svg";